'use client';

import React from 'react';
import { RadialBarChart, RadialBar, ResponsiveContainer, Tooltip } from 'recharts';

// Backend integration point: replace with /api/collection/type-distribution
const typeData = [
  { name: 'Electric', count: 6, fill: '#2563EB' },
  { name: 'Acoustic', count: 3, fill: '#D97706' },
  { name: 'Bass', count: 2, fill: '#7C3AED' },
  { name: 'Classical', count: 1, fill: '#059669' },
];

function CustomTooltip({ active, payload }: { active?: boolean; payload?: { payload: { name: string; count: number } }[] }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-card border border-border rounded-lg px-3 py-2 shadow-modal text-sm">
      <p className="font-600 text-foreground">{payload[0].payload.name}</p>
      <p className="text-muted-foreground">{payload[0].payload.count} guitars</p>
    </div>
  );
}

export default function GuitarTypeChart() {
  return (
    <div className="bg-card rounded-2xl p-5 shadow-card border border-border h-full">
      <div className="mb-4">
        <h3 className="text-sm font-700 text-foreground">Guitar Types</h3>
        <p className="text-xs text-muted-foreground mt-0.5">By category</p>
      </div>
      <ResponsiveContainer width="100%" height={180}>
        <RadialBarChart
          cx="50%"
          cy="50%"
          innerRadius="25%"
          outerRadius="90%"
          data={typeData}
          startAngle={90}
          endAngle={-270}
          barSize={14}
        >
          <RadialBar dataKey="count" background={{ fill: 'var(--muted)' }} cornerRadius={4} />
          <Tooltip content={<CustomTooltip />} />
        </RadialBarChart>
      </ResponsiveContainer>
      <div className="space-y-1.5 mt-2">
        {typeData.map((item) => (
          <div key={`type-legend-${item.name}`} className="flex items-center justify-between text-xs">
            <div className="flex items-center gap-1.5">
              <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: item.fill }} />
              <span className="text-muted-foreground">{item.name}</span>
            </div>
            <span className="font-600 text-foreground tabular-nums">{item.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
}